export type Flow = 'date-range' | 'export'

/**
 * Tracking identifiers per upgrade flow, shared by the dialog's impression
 * effect and the consumer click hooks so the `Upgrade Path Viewed` and
 * `CTA Clicked` halves of each funnel always report the same cta / upgrade path.
 */
export const FLOW_TRACKING: Record<
  Flow,
  { cta: CTA; upgradePathName: string }
> = {
  'date-range': {
    cta: 'publish-insights-customDateRange-upgrade-1',
    upgradePathName: 'insightsCustomDate-upgrade',
  },
  export: {
    cta: 'publish-insights-csvExport-upgrade-1',
    upgradePathName: 'insights-csvExport-upgrade',
  },
}
